import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.productionMode) {
  enableProdMode();
  Sentry.init({
    dsn: environment.sentryDns,
    integrations: [],
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
  console.error(err);
});
